import { Title } from '@app/components/core/typography/Title'

export const SectionHeader = ({ title }: { title: string }) => {
  return <Title.H4>{title}</Title.H4>
}
